module.exports = __webpack_public_path__ + "src/assets/img/cnumber1.21df7e86.png";